import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { JobDatesComponent } from 'src/app/jobs/job-dates/job-dates.component';
import { LabourJobService } from '../labour-job.service';
import { CompetenciesService } from 'src/app/services/competencies.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { MapsService } from 'src/app/services/maps.service';
import { FilterService } from 'src/app/services/filter.service';
import { UtilityService } from 'src/app/services/utility.service';
import { ErrorStateMatcher } from '@angular/material';
declare var what3words: any;


@Component({
  selector: 'app-labour-job-create',
  templateUrl: './labour-job-create.component.html',
  styleUrls: ['./labour-job-create.component.scss']
})

// export class MyErrorStateMatcher implements ErrorStateMatcher {
//   isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
//     const isSubmitted = form && form.submitted;
//     return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
//   }
// }

export class LabourJobCreateComponent implements OnInit {

  @ViewChild(JobDatesComponent, { static: false }) jobDateComp: JobDatesComponent;

  labourjobForm: FormGroup
  latitude: number;
  longitude: number;
  address: any;
  what3words = {}
  competencyList = []
  competencyListCopy = []
  staffUserList = []
  staffUserListCopy = []
  clientList = []
  jobList = []
  allJobs = []
  assetCategoryList = []
  isdisablePOnum = true
  jobOperativeList = []
  isAdd = true
  duration
  startingDate
  endingDate
  startTime
  endTime
  totalTime
  isSchedule = false
  singleJobDate = [];
  searchText
  existingUserData = []
  isView = false
  totalChargeRate = 0
  totalPayRate = 0
  totalProfit = 0
  totalHoursWorked = { hours: 0, minutes: 0 };
  displayHours = "00:00"
  isComp = true
  loading = false
  isSubmit = false
  isMapEdit = false

  // matcher = new MyErrorStateMatcher();


  constructor(
    public formBuilder: FormBuilder,
    private _router: Router,
    public _labourjobService: LabourJobService,
    public _competencyService: CompetenciesService,
    public _cd: ChangeDetectorRef,
    public _mapService: MapsService,
    public _filter: FilterService,
    public _utilityService: UtilityService,
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.filteronCompetency()
    this.getRequiredjobData()
  }



  // FORM GROUP
  createForm() {
    this.labourjobForm = this.formBuilder.group({
      jobTitle: new FormControl('', Validators.required),
      ponumber: this.formBuilder.array(this.multiplePOnumber([])),
      clients: this.formBuilder.array(this.multipleClients([])),
      jobLocation: new FormControl(''),
      locationType: new FormControl('labourjob'),
      coordinates: new FormControl([]),
      address: this.formBuilder.array(this.addresList([])),
      what3words: new FormControl(''),
      startDate: new FormControl('', Validators.required),
      endDate: new FormControl('', Validators.required),
      startTime: new FormControl('', Validators.required),
      endTime: new FormControl('', Validators.required),
      operatives: this.formBuilder.array([]),
      multipleOperatives: this.formBuilder.array(this.multipleOperativeSelect()),
      linkedAssets: this.formBuilder.array(this.multipleAssets([])),
    })
    this.changeFormvalue()
  }




  changeFormvalue() {
    this.labourjobForm.valueChanges.subscribe(value => {
      console.log("AFTER VALUE ASSIGN TO FORM CONTROL", value);
      if (value.startDate != '' && value.endDate != '' && value.startTime != '' && value.endTime != '') {
        let startTime = moment(value.startTime, 'HH:mm:ss a').valueOf();
        let endTime = moment(value.endTime, 'HH:mm:ss a').valueOf();
        this.startTime = value.startTime
        this.endTime = value.endTime
        this.totalTime = this.calculateTime(value.startTime, value.endTime, value.startDate)
        if (this.singleJobDate && this.singleJobDate.length) {
          this.singleJobDate = this.singleJobDate.filter((x) => x.totalhours = this.totalTime)
          this.calculatePlannedhours()
        }
        this.isSchedule = true
        // this.emptyFrequencyDates()
        // this.verifyUsersList()
      }
      if (value.operatives && value.operatives.length) {
        this.calculateAmount(value.operatives)
        value.operatives.filter((x) => {
          if (x.operatives !== '') {
            console.log("VALUE OF OPERATIVE", x)
            let element = this.jobOperativeList.findIndex((y) => y.userId._id === x.operatives.userId._id)
            if (element == -1) this.jobOperativeList.push(x.operatives)
          }
        })
      }
      if (value.linkedAssets && value.linkedAssets.length) this.disableAssets()
      if (value.ponumber) this.disablePOnumber(value.ponumber)
    });
  }

  calculateTime(startTime, endTime, calDate) {
    console.log("CALCULATE TOTAL TIME", startTime, endTime, calDate)
    let minutes
    let hours
    let startHours = startTime.split(":")[0]
    let startMinutes = startTime.split(":")[1]
    let endHours = endTime.split(":")[0]
    let endMinutes = endTime.split(":")[1]
    let time1: any
    let time2: any
    let difference
    let date = moment(calDate)
    if (endHours >= startHours && endHours <= 23) {
      time1 = new Date(date.toDate().setHours(startHours, startMinutes));
      time2 = new Date(date.toDate().setHours(endHours, endMinutes));
    } else {
      time1 = new Date(date.toDate().setHours(startHours, startMinutes));
      let tempDate = moment(date, "MM-DD-YYYY").add(1, "days")
      time2 = new Date(tempDate.toDate().setHours(endHours, endMinutes));
    }
    difference = (time2 - time1) / 60000;
    if (difference < 0) return ({ hours: 0, minutes: 0 })
    else
      minutes = difference % 60;
    hours = (difference - minutes) / 60;
    return hours + ":" + minutes
  }



  // Operative Selection with Competency with old structure

  get multipleOperativeGroup() { return <FormArray>this.labourjobForm.get('operatives') }


  // Multiple operative selection process start

  get multipleOperativeSelectionGroup() { return <FormArray>this.labourjobForm.get('multipleOperatives') }

  multipleOperativeSelect() {
    return [this.formBuilder.group({
      competency: new FormControl(''),
      operatives: new FormControl(''),
      competencyList: new FormControl(this.competencyList),
      operativeList: new FormControl('')
    })]
  }

  addMultipleCompetency() {
    const control = <FormArray>this.labourjobForm.controls.multipleOperatives
    control.push(this.formBuilder.group({
      competency: new FormControl(''),
      operatives: new FormControl(''),
      competencyList: new FormControl(this.competencyList),
      operativeList: new FormControl('')
    }))
  }


  deleteCompetency(data, index) {
    console.log("INDEX OF COMPETENCY", index)
    const control = <FormArray>this.labourjobForm.controls.multipleOperatives
    const operativeList = <FormArray>this.labourjobForm.controls.operatives
    let operativeData = operativeList.value.filter((x) => x.mainIndex === index)
    console.log("THIS IS THE OPERATIVE DATA", operativeData)
    if (operativeData && operativeData.length) {
      for (let i = 0; i < operativeData.length; i++) {
        const operativeIndex = operativeList.value.findIndex((x) => x.operatives._id === operativeData[i].operatives._id)
        operativeList.removeAt(operativeIndex)
        // operativeList.removeAt(i)
      }
    }
    control.removeAt(index)
    this.calculatePlannedhours()
  }


  // Get address list from formgroup
  getAddressList() {
    return this.labourjobForm.get('address') as FormArray;
  }

  // Generate formarray for address list
  addresList(address) {
    if (address && address.length) {
      let locationArray = []
      _.forEach(address, async (singleLocation) => {
        await locationArray.push(new FormGroup({
          title: new FormControl({ value: (singleLocation && singleLocation.title) ? singleLocation.title : singleLocation.title }),
        }))
      })
      return locationArray;
    } else {
      return [this.formBuilder.group({
        title: new FormControl('')
      })]
    }
  }


  get multipleClientsGroup() { return <FormArray>this.labourjobForm.get('clients') }
  multipleClients(clients) {
    let clientList = []
    if (clients && clients.length) {
      _.forEach(clients, async (user) => {
        let index = this.clientList.findIndex((x) => x._id == user.client._id)
        if (index != -1) this.clientList[index]['isSelected'] = true
        await clientList.push(new FormGroup({
          client: new FormControl({ value: (user && user.client) ? user.client : '' }, Validators.required),
        }))
      })
      return clientList;
    } else {
      return [this.formBuilder.group({
        client: new FormControl('', Validators.required),
      })]
    }
  }





  AddMultipleClients() {
    const control = <FormArray>this.labourjobForm.controls.clients
    control.push(this.formBuilder.group({
      client: new FormControl('', Validators.required),
    }))

  }

  deleteClient(index, item) {
    const control = <FormArray>this.labourjobForm.controls.clients
    control.removeAt(index)
    let clientindex = this.clientList.findIndex((x) => x._id == item.value.client._id)
    if (clientindex != -1) this.clientList[clientindex]['isSelected'] = false
  }

  clientChanged(event, item) {
    const control = <FormArray>this.labourjobForm.controls.clients
    this.clientList = this.clientList.filter((x) => {
      let index = control.value.findIndex((y) => y.client._id == x._id)
      if (index != -1) x['isSelected'] = true
      else x['isSelected'] = false
      return x
    })
  }



  // Get address list from formgroup
  get getPOlist() { return this.labourjobForm.get('ponumber') as FormArray; }


  multiplePOnumber(poList) {
    if (poList && poList.length) {
      let poListdata = []
      _.forEach(poList, async (singlePO) => {
        await poListdata.push(new FormGroup({
          potext: new FormControl({ value: (singlePO && singlePO.potext) ? singlePO.potext : '' }),
          reason: new FormControl({ value: (singlePO && singlePO.reason) ? singlePO.reason : '' }),
        }))
      })
      return poListdata;
    } else {
      return [this.formBuilder.group({
        potext: new FormControl(''),
        reason: new FormControl(''),
      })]
    }
  }


  disablePOnumber(POnumbers) {
    let lastPOnumber = POnumbers[POnumbers.length - 1]
    if (lastPOnumber.potext !== '') this.isdisablePOnum = false
    else this.isdisablePOnum = true
  }

  addMultiplePOnumber() {
    const control = <FormArray>this.labourjobForm.controls.ponumber
    control.push(this.formBuilder.group({
      potext: new FormControl(''),
      reason: new FormControl(''),
    }))
  }

  deletePOnumber(index) {
    const control = <FormArray>this.labourjobForm.controls.ponumber
    control.removeAt(index)
  }


  get multipleAssetcategoryGroup() { return <FormArray>this.labourjobForm.get('linkedAssets') }

  multipleAssets(assets) {
    let assetList = []
    if (assets && assets.length) {
      _.forEach(assets, async (user) => {
        let index = this.clientList.findIndex((x) => x._id == user.client._id)
        if (index != -1) this.clientList[index]['isSelected'] = true
        await assetList.push(new FormGroup({
          client: new FormControl({ value: (user && user.client) ? user.client : '' }, Validators.required),
        }))
      })
      return assetList;
    } else {
      return [this.formBuilder.group({
        assetCategory: new FormControl(''),
        assetList: new FormControl([]),
        selectedAsset: new FormControl(''),
        assignOperative: new FormControl([]),
        linkedAsset: new FormControl([]),
        operativeList: new FormControl(this.jobOperativeList)
      })]
    }
  }


  addMultipleAssets() {
    const control = <FormArray>this.labourjobForm.controls.linkedAssets
    control.push(this.formBuilder.group({
      assetCategory: new FormControl(''),
      assetList: new FormControl([]),
      selectedAsset: new FormControl(''),
      assignOperative: new FormControl([]),
      operativeList: new FormControl(this.jobOperativeList),
      linkedAsset: new FormControl([])
    }))
  }


  deleteAssets(item, index) {
    const control = <FormArray>this.labourjobForm.controls.linkedAssets
    control.removeAt(index)
  }


  disableAssets() {
    const control = <FormArray>this.labourjobForm.controls.linkedAssets
    let selectedAsset = control.value
    let lastElement = selectedAsset[selectedAsset.length - 1]
    if (lastElement.assetCategory != '') this.isAdd = false
    else this.isAdd = true
  }

  // UTILITY


  // Set current Location in form group
  setCurrentLocation(mapCurrentValue) {
    this.latitude = mapCurrentValue.latitude
    this.longitude = mapCurrentValue.longitude
    this.address = mapCurrentValue.address
    let splitAddress = this.address.split(',')
    this.labourjobForm.patchValue({
      coordinates: [this.longitude, this.latitude],
      jobLocation: this.address,
    })
    this.getAddressList().clear()
    this.updateAddressData(splitAddress)
    this.getWhat3words(this.latitude, this.longitude)
    // this.updateOperativePlannedTime()
  }


  // Update the address details in array formate
  updateAddressData(address) {
    const control = this.getAddressList()
    address.forEach(element => {
      control.push(
        this.formBuilder.group({
          title: element
        })
      )
    });
  }
  // Generate What3words for selected location
  getWhat3words(latitude, longitude) {
    what3words.api.convertTo3waGeoJson({ lat: latitude, lng: longitude }, 'en').then((words) => {
      this.what3words = { what3wordsLink: words.features[0].properties.map, what3words: words.features[0].properties.words }
      this._cd.detectChanges()
      this.labourjobForm.patchValue({ what3words: { what3wordsLink: words.features[0].properties.map, what3words: words.features[0].properties.words } })
    })
  }

  assetCategorySelect(item, i) {
    const control = <FormArray>this.labourjobForm.controls.linkedAssets
    const currentCategory = item.value
    const currentFormdata = this.labourjobForm.controls.linkedAssets.value
    const mainAssetList = this.assetCategoryList.find((x) => x._id === currentCategory.assetCategory._id)
    const categoryData = currentFormdata.filter((x) => x.assetCategory._id === currentCategory.assetCategory._id)
    let assetList = []
    const allAssetList = mainAssetList.assetList
    const assetLength = allAssetList.length
    for (let i = 0; i < assetLength; i++) {
      const elemenet = currentFormdata.find((x) => x.selectedAsset._id === allAssetList[i]._id)
      let isExits
      if (elemenet == undefined) {
        isExits = this.verifyAssetDate(allAssetList[i])
        allAssetList[i]['isSelected'] = isExits
      } else {
        allAssetList[i]['isSelected'] = true
      }
      assetList.push(allAssetList[i])
    }
    control.at(i).patchValue({ assetList: assetList })
  }

  // Here verify asset data with previous jobs or future jobs linked assets date
  // If asset is used in another job then that asset is not select in current job
  verifyAssetDate(asset) {
    const jobLength = this.allJobs.length
    let isEnd
    let isStart
    for (let i = 0; i < jobLength; i++) {
      const assetAvalible = this.allJobs[i].linkedAssets.filter((x) => x.selectedAsset._id === asset._id)
      if (assetAvalible && assetAvalible.length) {
        for (let j = 0; j < assetAvalible.length; j++) {
          const currentStartDate = this.labourjobForm.value.startDate
          const currentEndDate = this.labourjobForm.value.endDate
          const existingStartDate = this.allJobs[i].startDate
          const existingEndDate = this.allJobs[i].endDate
          isStart = this.checkDate(existingStartDate, existingEndDate, currentStartDate)
          isEnd = this.checkDate(existingStartDate, existingEndDate, currentEndDate)
          if (isStart || isEnd) break;
        }
      }
      else {
        isStart = false
        isEnd = false
      }
      if (isStart || isEnd) break;
    }
    if (!isStart && !isEnd) return false
    else return true
  }



  assetSelection(event, item, index) {
    const control = <FormArray>this.labourjobForm.controls.linkedAssets
    let selectedAsset = item.value.selectedAsset
    let linkedAssetList = selectedAsset.linkedAsset
    const linkedAssetLength = linkedAssetList.length
    const otherjobsLinkedAsset = this.getOtherjobLinkedAsset(item)
    for (let i = 0; i < linkedAssetLength; i++) {
      const currentAsset = otherjobsLinkedAsset.filter((x) => x._id === linkedAssetList[i]._id)
      let isEnd
      let isStart
      if (currentAsset && currentAsset.length) {
        for (let j = 0; j < currentAsset.length; j++) {
          const currentStartDate = this.labourjobForm.value.startDate
          const currentEndDate = this.labourjobForm.value.endDate
          const existingStartDate = currentAsset[j].startDate
          const existingEndDate = currentAsset[j].endDate
          isStart = this.checkDate(existingStartDate, existingEndDate, currentStartDate)
          isEnd = this.checkDate(existingStartDate, existingEndDate, currentEndDate)
          if (isStart || isEnd) break;
        }
        if (isStart || isEnd) linkedAssetList[i]['isSelected'] = true
        else linkedAssetList[i]['isSelected'] = false
      } else {
        linkedAssetList[i]['isSelected'] = false
        // isStart = false
        // isEnd = false
      }
      // if (isStart || isEnd) break;
    }
    selectedAsset['linkedAsset'] = linkedAssetList
    control.at(index).patchValue({ selectedAsset: selectedAsset })
  }

  getOtherjobLinkedAsset(asset) {
    const jobLength = this.allJobs.length
    let linkedAsset = []
    for (let i = 0; i < jobLength; i++) {
      const singleJob = this.allJobs[i]
      if (singleJob.linkedAssets && singleJob.linkedAssets.length) {
        const assetList = singleJob.linkedAssets
        const assetLength = assetList.length
        for (let j = 0; j < assetLength; j++) {
          assetList[j].linkedAsset = assetList[j].linkedAsset.map((x) => {
            x['startDate'] = singleJob.startDate,
              x['endDate'] = singleJob.endDate
            return x
          })
          linkedAsset = linkedAsset.concat(assetList[j].linkedAsset)
        }
      }
    }
    const currentjobAssets = this.labourjobForm.value
    if (currentjobAssets.linkedAssets && currentjobAssets.linkedAssets.length) {
      const currentLinkedAssets = currentjobAssets.linkedAssets
      for (let k = 0; k < currentLinkedAssets.length; k++) {
        if (currentLinkedAssets[k].selectedAsset._id !== asset.value.selectedAsset._id) {
          currentLinkedAssets[k].linkedAsset = currentLinkedAssets[k].linkedAsset.map((x) => {
            x['startDate'] = currentjobAssets.startDate
            x['endDate'] = currentjobAssets.endDate
            return x
          })
          linkedAsset = linkedAsset.concat(currentLinkedAssets[k].linkedAsset)
        }
      }
    }
    return linkedAsset
  }


  checkDate(fromDate, toDate, checkDate) {
    let dateFrom = fromDate
    let dateTo = toDate
    let dateCheck = checkDate
    let d1 = dateFrom.split("/");
    let d2 = dateTo.split("/");
    let c = dateCheck.split("/");
    let from = new Date(d1);  // -1 because months are from 0 to 11
    let to = new Date(d2);
    let check = new Date(c);
    const checkFlag = check <= from && check >= to
    return check >= from && check <= to
  }


  onChange(value, formControl) {
    if (formControl === 'startDate') {
      this.startingDate = value
      this.labourjobForm.patchValue({ startDate: value })
    }
    let endDateValue = this.labourjobForm.get('endDate').value
    if (formControl === 'startDate' && endDateValue) {
      let startDate = this.labourjobForm.get('startDate').value
      this.duration = this.calculateDuration(startDate, endDateValue)
    }
    if (formControl === 'endDate') {
      this.endingDate = value
      let startDate = this.labourjobForm.get('startDate').value
      this.duration = this.calculateDuration(startDate, value)
      this.labourjobForm.patchValue({ endDate: value })
    }
    this.emptyFrequencyDates()
    // this.jobDateComp.enableCheckBoxes();
  }

  openCompetencySelect(index) {

    // console.log("WHEN MAT SELECT OPEN", index , this.competencyList);
    // console.log("THIs is another list", this.competencyListCopy);

    this.searchText = ''
    const control = <FormArray>this.labourjobForm.controls.multipleOperatives
    // console.log("VALUE OF SPECIFIC INEDX", control.at(index).value);
    let existingCompeteny = control.at(index).value.competency
    let finalList = []
    let staticList = this.competencyList.slice(0)
    if (existingCompeteny && existingCompeteny.length) {
      for (let i = 0; i < existingCompeteny.length; i++) {
        let index = staticList.findIndex((x) => (x.title === existingCompeteny[i].title) && (x.alias === existingCompeteny[i].alias))
        // console.log("THIS IS INDEX", index);              
        staticList.splice(index, 1)
      }
      console.log("AFTER STATIC LIST REMOVED COMPETENCY", staticList);
      finalList = [...existingCompeteny, ...staticList]
    } else {
      finalList = staticList
    }
    control.at(index).patchValue({ competencyList: finalList })
    return
  }


  multipleCompetencySelect(event, item, index) {
    let existingUsers = []
    let competencyList = event.value
    let existingCompeteny = this.labourjobForm.controls['multipleOperatives'].value.filter((x, currentIndex) => {
      console.log("THIS IS THE CURRENT INDEX AND MAIN INDEX", currentIndex, index)
      if (currentIndex !== index) {
        let temp = x.competency.filter((y) => competencyList.find((z) => z.alias == y.alias))
        if (temp && temp.length) return x
      }
    })
    let currentControl = <FormArray>this.labourjobForm.controls.multipleOperatives
    console.log("THIS IS EXISTING COMPETENCY LIST", existingCompeteny, currentControl.at(index), competencyList);
    if (existingCompeteny && existingCompeteny.length) {
      existingCompeteny.filter((x) => {
        // if (x.operatives != '') existingUsers.push(x.operatives)
        if (x.operatives && x.operatives.length) existingUsers = existingUsers.concat(x.operatives)
      })
    }
    let list = []
    let userLength = this.staffUserListCopy.length
    for (let i = 0; i < userLength; i++) {
      let x = this.staffUserListCopy[i]
      let userComp = []
      for (let j = 0; j < competencyList.length; j++) {
        let existComp = x.competencies.find((z) => z.alias == competencyList[j].alias)
        if (existComp != undefined) userComp.push(competencyList[j])
      }
      console.log("VALUE OF USER COMPONENT TO BE DISPLAY", userComp)
      if ((userComp && userComp.length) == (competencyList && competencyList.length) && (competencyList && competencyList.length !== 0)) {
        list.push(x)
      }
    }
    console.log("COMPETENCY LIST TO BE CHECKED", existingUsers, list);
    let finalUserList = []
    finalUserList = list.filter(function (obj) { return existingUsers.indexOf(obj) == -1; });
    console.log("THIS IS FINAL USER LIST TO BE DISPLAY", finalUserList, existingUsers, list);
    const control = <FormArray>this.labourjobForm.controls.multipleOperatives
    control.at(index).patchValue({ operativeList: finalUserList })
    if (competencyList && competencyList.length === 0) {
      control.at(index).patchValue({ operatives: '' })
    }
    console.log("THIS IS THE FORM DATA TO BE DISPLAY", this.labourjobForm.value);
  }



  // Search on competency title and alias
  competencyFilter(searchText, index) {
    const control = <FormArray>this.labourjobForm.controls.multipleOperatives
    // console.log("VALUE OF SPECIFIC INEDX", control.at(index).value);
    let existingCompeteny = control.at(index).value.competency
    this.competencyList = this.competencyListCopy
    let finalList = []
    if (searchText === '') {
      let staticList = this.competencyListCopy
      if (existingCompeteny && existingCompeteny.length) {
        for (let i = 0; i < existingCompeteny.length; i++) {
          let index = staticList.findIndex((x) => (x.title === existingCompeteny[i].title) && (x.alias === existingCompeteny[i].alias))
          console.log("THIS IS INDEX", index);
          staticList.splice(index, 1)
        }
        console.log("AFTER STATIC LIST REMOVED COMPETENCY", staticList);

        finalList = [...existingCompeteny, ...staticList]
      } else {
        finalList = staticList
      }
      control.at(index).patchValue({ competencyList: finalList })
      return;
    }
    let data = this.competencyList
    let tempDataSource = this._filter.filter1(searchText, data, ['title', 'alias']);
    if (existingCompeteny && existingCompeteny.length) finalList = [...existingCompeteny, ...tempDataSource]
    else finalList = tempDataSource
    control.at(index).patchValue({ competencyList: finalList })
  }

  async selectOperative(item, index) {
    console.log("THIS IS THE SINGLE ITEM", item.value)
    console.log("INDEX OF SELECTED OPERATIVE", index)
    let operativeData = item.value.operatives
    const control = <FormArray>this.labourjobForm.controls.operatives
    let currentControl = control.value.filter((x) => x.mainIndex === index)
    console.log("THIS IS THE CURRENT INDEX CONTROL", currentControl)
    this.isView = true
    for (let i = 0; i < operativeData.length; i++) {
      if (currentControl && !currentControl.length) {
        control.push(this.formBuilder.group({
          competency: new FormControl(item.value.competency),
          operatives: new FormControl(operativeData[i]),
          chargeRate: new FormControl(''),
          payRate: new FormControl(''),
          averageFatigueScore: new FormControl(''),
          averageRiskScore: new FormControl(''),
          frequencyDays: new FormControl([]),
          frequencyDates: new FormControl([]),
          plannedTravelTime: new FormControl(await this.calculatePlannedTravelTime(operativeData[i])),
          mainIndex: new FormControl(index),
          existingUserData: new FormControl(this.getExistingUserData(operativeData[i]))
        }))
      }
      else {
        const isExits = currentControl.find((x) => x.operatives._id === operativeData[i]._id)
        console.log("THIS IS THE EXISTING OPERATIVE", isExits)
        if (isExits === undefined) {
          control.push(this.formBuilder.group({
            competency: new FormControl(item.value.competency),
            operatives: new FormControl(operativeData[i]),
            chargeRate: new FormControl(''),
            payRate: new FormControl(''),
            averageFatigueScore: new FormControl(''),
            averageRiskScore: new FormControl(''),
            frequencyDays: new FormControl([]),
            frequencyDates: new FormControl([]),
            plannedTravelTime: new FormControl(await this.calculatePlannedTravelTime(operativeData[i])),
            mainIndex: new FormControl(index),
            existingUserData: new FormControl(this.getExistingUserData(operativeData[i]))
          }))
        }
      }
    }
    if (currentControl && currentControl.length) {
      for (let i = 0; i < currentControl.length; i++) {
        let isExits = operativeData.find((x) => x._id === currentControl[i].operatives._id)
        console.log("THIS IS THE EXISTING OPERATIVE", isExits)
        if (isExits === undefined) {
          control.removeAt(i)
        }
      }
    }
    console.log("CURRENT CONTROL VALUE", control)
    console.log("THIS IS THE FINAL FORM DATA", this.labourjobForm.value)
  }



  async calculatePlannedTravelTime(operative) {
    const operativeAddress = (operative && operative.locationDetails) ? operative.locationDetails._id.locationGeometry.coordinates : []
    const jobAddress = this.labourjobForm.controls.coordinates.value
    console.log("THIS IS THE JOB ADDRESS COORDINATED", jobAddress, operativeAddress, this.latitude, this.longitude)
    const travelTime: any = await this._mapService.getDistance(operativeAddress, jobAddress)
    console.log("WHAT IS THE TRAVEL TIME", travelTime)
    if (travelTime && travelTime.rows && travelTime.rows.length && travelTime.rows[0].elements[0].status === 'OK') {
      // console.log("TRAVEL TIME BASED ON LOCATION", travelTime)
      let plannedTime = travelTime.rows[0].elements[0].duration.text.split(' ')
      // console.log("THIS IS THE PLANNED TIME TO BE DISPLAY", plannedTime, plannedTime[0] + ':' + plannedTime[2])
      let hours
      let minutes
      for (let i = 0; i < plannedTime.length; i++) {
        if (plannedTime[0 + 1] === 'hours' || plannedTime[0 + 1] === 'hour') {
          hours = this.addPaddingValue(plannedTime[0], 2)
          minutes = this.addPaddingValue(plannedTime[2], 2)
        }
        if (plannedTime[0 + 1] === 'mins' || plannedTime[0 + 1] === 'min') {
          hours = '00'
          minutes = this.addPaddingValue(plannedTime[0], 2)
        }
      }
      // control.at (index).patchValue({ plannedTravelTime: hours + ':' + minutes })
      let finalTime = hours + ':' + minutes
      console.log("FINAL MINUTES AND HOURS OF USER", finalTime)
      return finalTime
    } else {
      console.log("CALL THIS ELSE PART FOR NO TRAVEL TIME")
      // control.at(index).patchValue({ plannedTravelTime: '' })
      return ''
    }
  }

  addPaddingValue(num, numZeros) {
    // console.log("h is calling or not", h);
    let n = Math.abs(num);
    // console.log("what is the n value", n);

    let zeros = Math.max(0, numZeros - Math.floor(n).toString().length);
    // console.log("what is the zero value", zeros);

    let zeroString = Math.pow(10, zeros).toString().substr(1);
    // console.log("what is the value of zero strinf", zeroString);

    if (num < 0) {
      zeroString = '-' + zeroString;
    }

    return zeroString + n;
  }


  getExistingUserData(operativeData) {
    const tempData = this.jobList.filter((x) => x._id === operativeData._id)
    console.log("THIS IS THE EXISTING USER DATA", tempData)
    return tempData
  }

  // Selected day wise date array 
  daySelection(obj, index) {
    console.log("SINGLE OBJECT DATA", obj)
    console.log("THERE IS THE SELECTED ITEM", index)
    const control = <FormArray>this.labourjobForm.controls.operatives
    let singleJobDates = obj.singleJobDates
    // this.singleJobDate = obj.singleJobDates;
    let arrayLength = singleJobDates.length;
    for (let i = 0; i < arrayLength; i++) {
      let date = new Date(singleJobDates[i].date)
      singleJobDates[i].date = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()
      singleJobDates[i].totalhours = this.totalTime
    }
    console.log("THIS IS THE TOTAL DATE LIST FOR ONE USER", singleJobDates)
    control.at(index).patchValue({ frequencyDates: singleJobDates, frequencyDays: obj.totalDays })
    // this.totalDays = obj.totalDays;
    if (this.totalTime != undefined) this.calculatePlannedhours()
    if (this.totalChargeRate != 0 || this.totalPayRate != 0) this.calculateAmount(this.multipleOperativeGroup.value)
    // console.log("SINGLE JOB DATE LIST", this.singleJobDate);

    this._cd.detectChanges()
    console.log("LABOUR JOB VALUE", this.labourjobForm.value)
  }


  calculatePlannedhours() {
    // console.log("TOTAL HOURS WORKED DATA", this.totalHoursWorked)
    if (this.totalHoursWorked == undefined) this.totalHoursWorked = { hours: 0, minutes: 0 }
    let totalH = 0;
    let totalM = 0;
    console.log("OPERATIVE USERS DATA", this.multipleOperativeGroup.value)
    const operativeList = this.multipleOperativeGroup.value
    const tempLength = operativeList.length
    for (let i = 0; i < tempLength; i++) {
      _.forEach(operativeList[i].frequencyDates, (day, index) => {
        let hours = day.totalhours.split(':')
        totalH = totalH + Number(hours[0]);
        totalM = totalM + Number(hours[1]);
      })
    }
    if (totalM > 60) {
      totalH = totalH + Math.floor(totalM / 60)
      totalM = totalM % 60
      this.totalHoursWorked.hours = totalH;
      this.totalHoursWorked.minutes = totalM;
    } else if (totalM == 60) {
      this.totalHoursWorked.hours = totalH + 1;
      this.totalHoursWorked.minutes = totalM - 60
    }
    else {
      this.totalHoursWorked.hours = totalH;
      this.totalHoursWorked.minutes = totalM;
    }
    this.displayHours = this.totalHoursWorked.hours + ":" + this.totalHoursWorked.minutes
  }


  async calculateAmount(list) {
    // if (this.singleJobDate && this.singleJobDate.length) {
    this.totalChargeRate = 0
    this.totalPayRate = 0
    if (this.totalTime == undefined) this.totalTime = await this.calculateTime(this.labourjobForm.controls.startTime.value, this.labourjobForm.controls.endTime.value, this.labourjobForm.controls.startDate.value)
    console.log("LIST OF ALL USERS ARE ADDED", this.totalTime, list)
    if (this.totalTime !== undefined) {
      let hours = this.totalTime.split(':')[0]
      let minutes = this.totalTime.split(':')[1]
      list.filter((x) => {
        x.frequencyDates.forEach((y) => {
          if (x.chargeRate && x.chargeRate != '') {
            this.totalChargeRate = this.totalChargeRate + (x.chargeRate * hours)
            if (minutes && minutes != 0) {
              let oneminAmount = (minutes * x.chargeRate) / 60
              this.totalChargeRate = this.totalChargeRate + oneminAmount
            }
          }
          if (x.payRate && x.payRate != '') {
            this.totalPayRate = this.totalPayRate + (x.payRate * hours)
            if (minutes && minutes != 0) {
              let oneminAmount = (minutes * x.payRate) / 60
              this.totalPayRate = this.totalPayRate + oneminAmount
            }
          }
        })
      })
      this.totalProfit = Number(this.totalChargeRate) - Number(this.totalPayRate)
      console.log("LIST OG ALL DATA", list, this.totalProfit, this.totalChargeRate)
    }
    const control = <FormArray>this.labourjobForm.controls.operatives
    let selectedComp = control.value
    let lastElement = selectedComp[selectedComp.length - 1]
    if (lastElement.competency != '') this.isComp = false
    else this.isComp = true
  }

  emptyFrequencyDates(event?) {
    const control = this.multipleOperativeGroup.value
    const formControl = this.multipleOperativeGroup
    const controlLength = control.length
    for (let i = 0; i < controlLength; i++) {
      const controlValue = control[i]
      if ((controlValue.frequencyDates && controlValue.frequencyDates.length) || (controlValue.frequencyDays && controlValue.frequencyDays.length)) {
        console.log("THIS IS THE EXISTING DATA", controlValue, control, formControl)
        formControl.at(i).patchValue({ frequencyDates: [], frequencyDays: [] })
      }
    }
    this.calculatePlannedhours()
  }
  // Calculation of duration 
  calculateDuration(startDate, endDate) {
    let date1: any = new Date(startDate);
    let date2: any = new Date(endDate);
    let diffTime = Math.abs(date2 - date1);
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays + 1
  }



  verifyFrequencyDates(data) {
    if (data.operatives && data.operatives.length) {
      const tempLength = data.operatives.length
      for (let i = 0; i < tempLength; i++) {
        let tempData = data.operatives[i]
        if (tempData.frequencyDates && !tempData.frequencyDates.length) {
          tempData['operatives'] = ''
          tempData['frequencyDays'] = []
          tempData['chargeRate'] = 0
          tempData['payRate'] = 0
          tempData['plannedTravelTime'] = '00:00'
        }
      }
    }
    console.log("THIS IS THE  DATA TO BE SEND TO DATABASE", data)
    return data
  }

  // API CALL


  // Filter on competency list
  filteronCompetency() {
    let comList
    let finalList = []

    this._competencyService.getCompetencyList().subscribe((data) => {
      comList = data
      comList.map(ele => {
        if (ele.value) ele.value.map(e => {
          finalList.push({ title: e.name, category: ele.viewValue, alias: e.alias })
        })
      })
      this.competencyList = finalList
      this.competencyListCopy = finalList
    })
  }



  // Get other required job details to create new job
  getRequiredjobData() {
    this._labourjobService.getRequiredjobData('test2').subscribe((data) => {
      console.log("DATA OF ALL REQUIRED JOB", data.jobs)
      this.clientList = data.clients
      this.jobList = data.jobs
      this.allJobs = data.allJobs
      this.staffUserList = data.staff
      this.staffUserListCopy = data.staff
      this.assetCategoryList = data.assetList
      // console.log("OTHER REQUIRED DATA FOR CREATE AND EDIT JOB", this.isEdit)
    }, error => {
      console.log("ERROR WHILE GET DATA", error);

    })
  }

  addLabourJob() {
    if (this.labourjobForm.valid) {
      this.loading = true
      // this.labourjobForm.value['totalDays'] = this.totalDays
      this.labourjobForm.value['singleJobDate'] = this.singleJobDate
      this.labourjobForm.value['plannedhours'] = this.totalHoursWorked
      let addformdata = this.verifyFrequencyDates(this.labourjobForm.value);
      this._labourjobService.createLabourjob(addformdata).subscribe((res) => {
        this.loading = false
        this._utilityService.handleSnackBar({ msg: "Job added successfully!", button: "Ok" })
        this._router.navigate(['/labour-job/view/' + res._id])
      }, err => {
        this._utilityService.handleSnackBar({ msg: "Something went wrong", button: "Ok" })
        this.loading = false
      })
    } else {
      this.labourjobForm.markAllAsTouched()
      this.isSubmit = true
    }
  }
}
